import { render, staticRenderFns } from "./DriversList.vue?vue&type=template&id=124a4478&scoped=true&"
import script from "./DriversList.vue?vue&type=script&lang=js&"
export * from "./DriversList.vue?vue&type=script&lang=js&"
import style0 from "./DriversList.vue?vue&type=style&index=0&id=124a4478&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124a4478",
  null
  
)

export default component.exports